export default function StatsPair({title, value}) {
  return (
    <div>
      <p className="text-stone-400 text-xs">{title.toUpperCase()}</p>
      <p className="font-bold text-stone-200 text-2xl">{value}</p>
    </div>
  );
}
